import { render, staticRenderFns } from "./CreateIndependentClassroomPage.vue?vue&type=template&id=40d6dd4a&scoped=true"
import script from "./CreateIndependentClassroomPage.vue?vue&type=script&lang=js"
export * from "./CreateIndependentClassroomPage.vue?vue&type=script&lang=js"
import style0 from "./CreateIndependentClassroomPage.vue?vue&type=style&index=0&id=40d6dd4a&prod&lang=stylus&scoped=true"
import style1 from "./CreateIndependentClassroomPage.vue?vue&type=style&index=1&id=40d6dd4a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d6dd4a",
  null
  
)

export default component.exports